module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('aside', [_c('sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('navbar'), _vm._v(" "), (!this.$route.meta.hideBreadcrumb) ? _c('Breadcrumb') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    style: ({
      top: this.$route.meta.hideBreadcrumb ? '80px' : '175px'
    })
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-def315a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/Main.vue
// module id = 1204
// module chunks = 2